import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  Button,
  ButtonCommonTheme,
} from "modules/theme";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalForm, ModalFormContainer } from "../../../../theme";
import { protocol } from "socket.io-client";
import Select from "react-select-plus";
import CommonManager from "../../../../../helpers/common";

export class RegionAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Region`;
    this.moduleUrl = `region`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
    this.commonManager = new CommonManager();
    this.protocolOptions = [
      { value: "https", label: "https" },
      { value: "http", label: "http" },
    ];
    this.socketProtocolOptions = [
      { value: "wss", label: "wss" },
      { value: "ws", label: "ws" },
    ];
  }
  setData(editData = "") {
    editData = editData || {};
    this.state = {
      region_name: editData.region_name || "",
      region: editData.region || "",
      endpoint: editData.endpoint || "",
      protocol: editData.protocol || "",
      socketProtocol: editData.socketProtocol || "",
      socket: editData.socket || "",
      cpassUrl: editData.cpassUrl || "",
      assestPublicUrl: editData.assestPublicUrl || "",
      assestPrivateUrl: editData.assestPrivateUrl || "",
      recordings: editData.recordings || "",
      messageProviderUrl: editData.messageProviderUrl || "",
      webchatUrl: editData.webchatUrl || "",
      webchatCDNUrl: editData.webchatCDNUrl || "",
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      region_name: "",
      region: "",
      endpoint: "",
      protocol: "",
      socketProtocol: "",
      socket: "",
      cpassUrl: "",
      assestPublicUrl: "",
      assestPrivateUrl: "",
      recordings: "",
      messageProviderUrl: "",
      webchatUrl: "",
      webchatCDNUrl: "",
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
    if (!this.commonManager.isValidUrl(this.state.cpassUrl.trim())) {
      Alert.error(`Enter a valid CPASS URL`);
      return true;
    } else if (!this.commonManager.isValidUrl(this.state.recordings.trim())) {
      Alert.error(`Enter a valid Recording URL`);
      return true;
    } else if (
      !this.commonManager.isValidUrl(this.state.assestPublicUrl.trim())
    ) {
      Alert.error(`Enter a valid Assest Public URL`);
      return true;
    } else if (
      !this.commonManager.isValidUrl(this.state.assestPrivateUrl.trim())
    ) {
      Alert.error(`Enter a valid Assest Private URL`);
      return true;
    } else if (
      !this.commonManager.isValidUrl(this.state.messageProviderUrl.trim())
    ) {
      Alert.error(`Enter a valid Message Provider URL`);
      return true;
    } else if (!this.commonManager.isValidUrl(this.state.webchatUrl.trim())) {
      Alert.error(`Enter a valid Web Provider URL`);
      return true;
    } else if (
      !this.commonManager.isValidUrl(this.state.webchatCDNUrl.trim())
    ) {
      Alert.error(`Enter a valid Webchat CDN URL`);
      return true;
    }
    let tData = {
      region_name: this.state.region_name,
      region: this.state.region,
      endpoint: this.state.endpoint,
      protocol: this.state.protocol,
      socketProtocol: this.state.socketProtocol,
      socket: this.state.socket,
      cpassUrl: this.state.cpassUrl,
      assestPublicUrl: this.state.assestPublicUrl,
      assestPrivateUrl: this.state.assestPrivateUrl,
      recordings: this.state.recordings,
      messageProviderUrl: this.state.messageProviderUrl,
      webchatUrl: this.state.webchatUrl,
      webchatCDNUrl: this.state.webchatCDNUrl,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public",
        { id: tData._id },
        "PUT"
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.closeModal(true);
          _this.props.update();
          Alert.success(`${this.moduleName} created successfully.`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public"
      );
    }
  }

  generateParams(tData) {
    return tData.map((tD) => ({
      value: tD.value,
      label: tD.label,
    }));
  }

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Region Name", {
                defaultValue: "",
                placeholder: "Region Name",
                autoFocus: true,
                required: true,
                id: "region_name",
                value: this.state.region_name,
                onChange: (e) => {
                  if (e.target.value === " " || e.target.value.length > 20) {
                    return false;
                  }
                  this.setState({
                    region_name: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Region", {
                defaultValue: "",
                placeholder: "Region",
                autoFocus: false,
                required: true,
                id: "region",
                value: this.state.region,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ region: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn style={{ flex: "0.2 0 auto" }}>
              {/* {this.renderFormGroup("protocol", {
                defaultValue: "",
                placeholder: "Protocol",
                autoFocus: false,
                required: true,
                id: "protocol",
                value: this.state.protocol,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ protocol: e.target.value });
                },
              })} */}
              <FormGroup>
                <ControlLabel required>Protocol</ControlLabel>
                <Select
                  defaultValue=""
                  placeholder="Protocol"
                  clearable={false}
                  searchable={false}
                  onChange={(item) => {
                    if (item) {
                      this.setState({
                        protocol: item.value || "https",
                      });
                    } else {
                      this.setState({ protocol: null });
                    }
                  }}
                  value={this.state.protocol}
                  options={this.generateParams(this.protocolOptions)}
                />
              </FormGroup>
            </FormColumn>
            <FormColumn>
              {this.renderFormGroup("Endpoint", {
                defaultValue: "",
                placeholder: "Endpoint",
                autoFocus: false,
                required: true,
                id: "endpoint",
                value: this.state.endpoint,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ endpoint: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn style={{ flex: "0.1 0 auto" }}>
              {/* {this.renderFormGroup("socket Protocol", {
                defaultValue: "",
                placeholder: "Socket Protocol",
                autoFocus: false,
                required: true,
                id: "socketProtocol",
                value: this.state.socketProtocol,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    socketProtocol: e.target.value,
                  });
                },
              })} */}
              <FormGroup>
                <ControlLabel required>Socket Protocol</ControlLabel>
                <Select
                  placeholder="Socket Protocol"
                  clearable={false}
                  searchable={false}
                  onChange={(item) => {
                    if (item) {
                      this.setState({
                        socketProtocol: item.value || "wss",
                      });
                    } else {
                      this.setState({ socketProtocol: null });
                    }
                  }}
                  value={this.state.socketProtocol}
                  options={this.generateParams(this.socketProtocolOptions)}
                />
              </FormGroup>
            </FormColumn>
            <FormColumn>
              {this.renderFormGroup("socket", {
                defaultValue: "",
                placeholder: "Socket",
                autoFocus: false,
                required: true,
                id: "socket",
                value: this.state.socket,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ socket: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("CPASS URL", {
                defaultValue: "",
                placeholder: "CPASS URL",
                autoFocus: false,
                required: true,
                id: "cpassUrl",
                value: this.state.cpassUrl,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ cpassUrl: e.target.value });
                },
              })}
            </FormColumn>
            <FormColumn>
              {this.renderFormGroup("recording URL", {
                defaultValue: "",
                placeholder: "Recording URL",
                autoFocus: false,
                required: true,
                id: "recordings",
                value: this.state.recordings,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ recordings: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("asset Public URL", {
                defaultValue: "",
                placeholder: "Asset Public URL",
                autoFocus: false,
                required: true,
                id: "assestPublicUrl",
                value: this.state.assestPublicUrl,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    assestPublicUrl: e.target.value,
                  });
                },
              })}
            </FormColumn>
            <FormColumn>
              {this.renderFormGroup("asset Private URL", {
                defaultValue: "",
                placeholder: "Asset Private URL",
                autoFocus: false,
                required: true,
                id: "assestPrivateUrl",
                value: this.state.assestPrivateUrl,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    assestPrivateUrl: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Message Provider URL", {
                defaultValue: "",
                placeholder: " Message Provider URL",
                autoFocus: false,
                required: true,
                id: "messageProviderUrl",
                value: this.state.messageProviderUrl,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ messageProviderUrl: e.target.value });
                },
              })}
            </FormColumn>
            <FormColumn>
              {this.renderFormGroup("Web Provider URL", {
                defaultValue: "",
                placeholder: "Web Provider URL",
                autoFocus: false,
                required: true,
                id: "webchatUrl",
                value: this.state.webchatUrl,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ webchatUrl: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Web Chat CDN URL", {
                defaultValue: "",
                placeholder: "Web Chat CDN URL",
                autoFocus: false,
                required: true,
                id: "webchatCDNUrl",
                value: this.state.webchatCDNUrl,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({ webchatCDNUrl: e.target.value });
                },
              })}
            </FormColumn>
            <FormColumn></FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
            modalBtnTitle="Cancel"
          />
          <ButtonCommonTheme
            disabled={this.state.loading}
            type="blueModalBtn"
            btnType="submit"
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

RegionAddEdit.propTypes = {
  group: PropTypes.array,
};

RegionAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default RegionAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/Region/components/RegionAddEdit.js